<div class="reveal-overlay">
  <div class="reveal sign-in sign-in--username">
    <mono-common-modal-header
      signInHeader="true"
      [headerText]="signInCms?.data?.attributes?.header"
    >
    </mono-common-modal-header>
    <main id="content" #content>
      <div class="grid-container" *ngIf="referringPageTitle !== ''">
        <div class="grid-x">
          <div class="cell">
              <mono-common-callout
                data-test="lmw-auth-sign-in-from-callout--info-box"
                base="info"
                type="info-box"
                [calloutText]="translate(temporarySigningInFromHelpHTML) | async"
                paddingOrMarginAlteration = 'margin-top-1 width-100'
              >
              </mono-common-callout>
          </div>
        </div>
      </div>
      <form [formGroup]="signInUsernameForm" [ngClass]="referringPageTitle === '' ? 'margin-top-2' : 'margin-top-1'">
        <fieldset>
          <legend class="show-for-sr">
            {{ signInCms?.data?.attributes?.username?.screenReaderLegend }}
          </legend>
          <label
            for="userName"
            id="userNameAriaId"
            [innerHTML]="signInCms?.data?.attributes?.username?.label"
            ></label>
            <mono-common-input-with-done-button
              [disableDoneButton]="signInUsernameForm.controls.userName.errors || canNavigate"
              (doneButtonClick)="doneButtonClicked()"
              [language]="authProcessProvider.language"
            >
            <ng-container input>
              <input
                #userSearch
                class="input-group-field"
                type="text"
                id="userName"
                formControlName="userName"
                (focus)="onUserSearchFocus()"
                aria-labelledby="userNameAriaId"
                aria-required="true"
              />
            </ng-container>
            </mono-common-input-with-done-button>
          <mono-common-help
            [action]="updateSignInStoreErrorAction"
            [title]="signInCms?.data?.attributes?.username?.usernameDoesNotExistHelp?.title"
            [message]="signInCms?.data?.attributes?.username?.usernameDoesNotExistHelp?.message"
            [closeButtonText]="signInCms?.data?.attributes?.username?.usernameDoesNotExistHelp?.closeButtonText"
            [helpPopupCalledFrom]="'sign-in'"
            (closeButtonExtras)="onHelpMessageClose()"
            [removeHelpMessage]="removeHelpMessage"
            [elementAttachedTo]="_userSearchInput"
          >
          </mono-common-help>
          <mono-common-help-popup
            [title]="signInCms?.data?.attributes?.username?.notLmwRegisteredHelp?.title"
            [message]="signInCms?.data?.attributes?.username?.notLmwRegisteredHelp?.description"
            helpPopupPosition="bottom"
            [open]="openNotLmwRegisteredHelp"
            [shadow]="false"
            (removeHelpMessage)="toggleNotLmwRegisteredHelp(false)"
            [helpPopupCalledFrom]="'sign-in'"
            [elementAttachedTo]="_userSearchInput"
            [pointer]="true"
          ></mono-common-help-popup>
          <mono-common-help-popup
            [title]="signInCms?.data?.attributes?.username?.lmwRegisterAttemptedHelp?.title"
            [message]="getUserUnverifiedViaLMWHtml()"
            helpPopupPosition="bottom"
            [open]="openUserUnverifiedViaLmwHelp"
            [shadow]="false"
            (removeHelpMessage)="toggleUserUnverifiedViaLmwHelp(false)"
            [helpPopupCalledFrom]="'sign-in'"
            [elementAttachedTo]="_userSearchInput"
            [pointer]="true"
          ></mono-common-help-popup>
          <mono-common-help-popup
            [title]="signInCms?.data?.attributes?.username?.verifyOnOCNError?.title"
            [message]="signInCms?.data?.attributes?.username?.verifyOnOCNError?.description"
            helpPopupPosition="bottom"
            [open]="openUserUnverifiedViaOCNHelp"
            [shadow]="false"
            (removeHelpMessage)="toggleUserUnverifiedViaOCNHelp(false)"
            [helpPopupCalledFrom]="'sign-in'"
            [elementAttachedTo]="_userSearchInput"
            [pointer]="true"
          ></mono-common-help-popup>
        </fieldset>
      </form>
    </main>
    <footer class="footer--sign-in">
      <div
        class="callout callout--register callout--register-vertical no-animation"
      >
        <p
        >
          {{ signInCms?.data?.attributes?.username?.noAccountYet }}
        </p>
        <a
          class="button button--icon-on-left centered clear flex-container align-middle"
          [routerLink]="[linkToRegistration]"
        >
          <svg
            class="icon icon--register icon--material"
            viewBox="0 0 24 24"
            width="24px"
            height="24px"
          >
            <use xlink:href="#icon-register" href="#icon-register"></use>
          </svg>
          <span
            >{{ signInCms?.data?.attributes?.username?.registerNow }}</span
          >
        </a>
      </div>
      <div class="button-container">
        <button
          [disabled]="!canNavigate"
          (click)="goToNextStage()"
          type="button"
          class="button primary expanded with-shadow"
        >
          <span
            *ngIf="!(showLoader | async)"
            >{{ signInCms?.data?.attributes?.username?.continueButton }}</span
          >
          <ng-container *ngIf="(showLoader | async) && email !== ''"
            ><span
              >{{ signInCms?.data?.attributes?.username?.checkingEmailLoader }}</span
            >
            <mono-common-loading-animation></mono-common-loading-animation>
          </ng-container>
          <ng-container *ngIf="(showLoader | async) && phoneNumber !== ''"
            ><span
              >{{ signInCms?.data?.attributes?.username?.checkingMobileLoader }}</span
            >
            <mono-common-loading-animation></mono-common-loading-animation>
          </ng-container>
        </button>
      </div>
    </footer>
  </div>
</div>
